// extracted by mini-css-extract-plugin
export default {"Tabs":"styles_Tabs__MA1Eq","tab":"styles_tab__Z7UUk","active":"styles_active__7mHCY","count":"styles_count__WevMm"};